import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ComponentAppearance } from '@unicup-ticketing/ui';

@Component({
  selector: 'ticketing-combined-logo',
  imports: [],
  templateUrl: './combined-logo.component.html',
  styleUrl: './combined-logo.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CombinedLogoComponent {
  appearance = input<ComponentAppearance>('dark');
}
